import { styled } from "styled-components";

export const DocsTemplateSectionWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  background: ${({ theme }) => theme.colors.default[50]};
  display: flex;
  justify-content: center;
  padding: 24px;
`;

export const DocsTemplateSectionContainer = styled.div`
  display: flex;
  padding: 60px 48px 48px 48px;
  flex-direction: column;
  align-items: flex-start;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  gap: 24px;
  width: 100%;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.base};
`;

export const OuterCommandContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 18px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.default[200]};
`;

export const InnerCommandContainer = styled.div``;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.default[900]};
  font-weight: 600;
  font-size: 32px;
  margin-bottom: 10px;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.default[500]};
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.03em;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 24px;

  &:first-of-type {
    grid-area: request;
  }

  &:last-of-type {
    grid-area: response;
  }
`;
export const DetailsTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
`;

export const BlockTableCell = styled.td`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  overflow-y: clip;
  overflow-x: auto;

  &:last-of-type {
    text-align: right;
    justify-content: end;
  }

  &[data-is-required="true"] {
    span svg path {
      fill: ${(props) => props.theme.colors.primary};
      stroke: ${(props) => props.theme.colors.primary};
    }
  }
  &[data-is-required="false"] {
    span {
      opacity: 0.2;
    }
  }
`;

export const BreadcrumbsContainer = styled.div`
  border-radius: 12px;
  margin-bottom: 24px;
  margin-left: -6px;
`;

export const Breadcrumb = styled.div`
  display: flex;
  gap: 4px;
  color: ${(props) => props.theme.colors.default.default}80;
  transition: 0.2s;
  font-weight: 500;
  align-items: center;
  button a {
    color: ${(props) => props.theme.colors.default.default}80;
    border-radius: 4px;
    padding: 4px 6px;
    transition: 0.2s;

    &:hover {
      background: ${(props) => props.theme.colors.default[900]}10;
      color: ${(props) => props.theme.colors.default[900]};
    }
  }
  button {
    &:focus-within {
      background: ${(props) => props.theme.colors.default.default}10;
    }
  }
  &[data-is-last="true"] {
    a {
      color: ${(props) => props.theme.colors.primary.default};
    }
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    font-size: 14px;
  }
`;
